import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent(props) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M14.106 5.075c.085-.124.386-.537.472-.663h-2.99L9.655 7.118c-.435.507-.267 1.608-.297 2.22a.79.79 0 01-.787.79H6.666a.79.79 0 01-.788-.79V8.042c0-.461.144-.912.413-1.287l1.675-2.344H4.975L3.303 6.756c-.27.375-.414.825-.412 1.287v9.363a1.346 1.346 0 001.343 1.344h6.772a1.347 1.347 0 001.344-1.344V8.043c0-.331.104-.655.297-.925l1.46-2.043z"
        fill="#919191"
      />
      <Path
        d="M6.503 8.043v1.294a.166.166 0 00.163.166h1.906a.164.164 0 00.162-.166V8.043c0-.461.144-.912.413-1.287l1.675-2.344h-2.09L6.8 7.118c-.193.27-.297.594-.297.925zM16.697 6.756l-1.34-1.878v3.406a.313.313 0 01-.626 0v-3.01l-1.25 1.75-.325.457a.977.977 0 00-.181.567v9.358c.001.375-.106.742-.31 1.056a1.99 1.99 0 01-.218.288h3.319a1.344 1.344 0 001.343-1.344V8.044a2.187 2.187 0 00-.412-1.288zM14.731 2.038a.791.791 0 00-.79-.788H6.059a.79.79 0 00-.79.788v1.75h9.462v-1.75z"
        fill="#919191"
      />
    </Svg>
  )
}

export default SvgComponent
